export enum Language {
  ENGLISH = 'english',
  DARI = 'dari',
  PASHTO = 'pashto',
}

export enum StoryStatus {
  DRAFT = 'draft',
  STAGE2 = 'stage2', // AI Review
  STAGE3 = 'stage3', // Editorial
  STAGE4 = 'stage4', // Final
  STAGE5 = 'stage5', // Social
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  DELETED = 'deleted',
}

export enum StoryType {
  BREAKING = 'breaking',
  FEATURE = 'feature',
  OPINION = 'opinion',
}

export interface User {
  id: string;
  name: string;
  email: string;
  // Added 'suspended' for soft-delete functionality
  role: 'journalist' | 'editor' | 'admin' | 'superuser' | 'suspended';
  avatar?: string;
  lastLogin: string;
}

export interface Story {
  id: string;
  groupId: string; // Links translations together
  isTranslation?: boolean; // New flag to track if this is a translation
  headline: string;
  deck: string;
  body: string;
  language: Language;
  type: StoryType;
  status: StoryStatus;
  createdAt: string;
  updatedAt: string;
  authorId: string;
  
  // Versions for tracking changes
  originalHeadline?: string;
  originalDeck?: string;
  originalBody?: string;
  
  // AI Workflow Data
  editorIssues?: string[];
  socialPosts?: SocialPosts;
}

export interface TerminologyItem {
  id: string;
  original: string; // The term to avoid or the source term
  replacement: string; // The correct term to use
  language: Language; // Which language this applies to
  type: 'forbidden' | 'standard'; // Forbidden = never use (e.g. Iranian Farsi terms), Standard = preferred spelling
  context?: string; // Notes for the AI
  createdBy?: string; // User ID
  createdAt?: string; // ISO Date string
}

export interface AuditLog {
  id: string;
  userId: string;
  userName: string;
  action: string; // e.g., "Logged In", "Published Story", "Updated Terminology"
  details?: string;
  timestamp: string;
}

export interface SocialPosts {
  twitter?: PlatformPosts;
  facebook?: PlatformPosts;
  telegram?: PlatformPosts;
  instagram?: PlatformPosts;
}

export interface PlatformPosts {
  short: string;
  medium: string;
  long: string;
}

export interface AIResponse {
  content: string;
  provider: string;
  model: string;
  tokensUsed?: number;
  error?: string;
}

export interface JournalistResponse {
  headline: string;
  deck: string;
  body: string;
}

export interface CriticResponse {
  issues: string[];
}